import { LtmCancellationActionTypes } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const getConfig = createAsyncMapAction(LtmCancellationActionTypes.GET_CONFIG, p => p.userId);
export const quoteCancellation = createAsyncMapAction(LtmCancellationActionTypes.QUOTE_CANCELLATION, p => p.subscriptionId);
export const quoteAutocycle = createAsyncMapAction(LtmCancellationActionTypes.QUOTE_AUTOCYCLE, p => p.subscriptionId);
export const confirmCancellation = createAsyncMapAction(LtmCancellationActionTypes.CONFIRM_CANCELLATION, p => p.cancellationRequestId);
